// extracted by mini-css-extract-plugin
module.exports = {"solution":"solution_solution__z_KtQ"};